import React from 'react';
import GroupName from '../Components/GroupName';
import './pages.css';
import Breadcrumbs, { IBreadcrumb } from '../Components/Breadcrumbs';

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'Home',
    href: '/',
    className: 'breadcrumb-link',
  },
  {
    name: 'Groups',
    href: '',
    isCurrent: true,
    className: 'breadcrumb-current',
  },
];

const Groups = () => {
  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} className="breadcrumb" />
      <GroupName />
    </>
  );
};

export default Groups;
